var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('material-support-card'),_c('div',{staticClass:"mt-4"},[_c('material-support-open-tickets-table')],1),_c('div',{staticClass:"mt-4"},[_c('material-support-closed-tickets-table')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }